import * as Types from '../../../util/graphql/api.graphql';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';

export const DeleteObservationDocument = gql`
  mutation DeleteObservation($id: String!) {
    deleteObservation(id: $id)
  }
`;
export type DeleteObservationMutationFn = ApolloReactCommon.MutationFunction<
  DeleteObservationMutationResponse,
  DeleteObservationMutationVariables
>;

/**
 * __useDeleteObservationMutation__
 *
 * To run a mutation, you first call `useDeleteObservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteObservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteObservationMutation, { data, loading, error }] = useDeleteObservationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteObservationMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteObservationMutationResponse,
    DeleteObservationMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    DeleteObservationMutationResponse,
    DeleteObservationMutationVariables
  >(DeleteObservationDocument, baseOptions);
}
export type DeleteObservationMutationHookResult = ReturnType<
  typeof useDeleteObservationMutation
>;
export type DeleteObservationMutationResult =
  ApolloReactCommon.MutationResult<DeleteObservationMutationResponse>;
export type DeleteObservationMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    DeleteObservationMutationResponse,
    DeleteObservationMutationVariables
  >;
export type DeleteObservationMutationVariables = Types.Exact<{
  id: Types.Scalars['String'];
}>;

export type DeleteObservationMutationResponse = {
  __typename: 'Mutation';
  deleteObservation: boolean;
};
